import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const threads: Platform = {
  id: 'threads',
  name: 'Threads',
  iconIndex: PlatformRegistry.threads.index,
  color: PlatformRegistry.threads.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://www.threads.net/intent/post', {
      url: content.url,
      text: content.title,
    });
  },
};

